module.exports = __webpack_public_path__ + "img/assignee_blue.f660d13c.svg";